import Vue from 'vue'
import common from './common.js'
import config from './config'
import md5 from 'js-md5'
import {
  post,
  get,
  postForm,
  postJson,
  getJson,
  postJsonForLongTimeout,
  getBase64data,
  getExcel,
  postImg
} from './http.js'
import axios from 'axios'
import {
  postData
} from './http'
import store from '../store/index.js'
import {
  Toast,
  ImagePreview,
  Dialog
} from 'vant'

Vue.use(Toast)
Vue.use(ImagePreview)
Vue.use(Dialog)

export function log (logStr) {
  // this.$log(logStr);
}

export function initConfig () {
  this.$log('==initConfig==')
  get('config.json').then(response => {
    this.$log('==initConfig==')
    this.$log(response.config)
    common.config = response.config
  })
}

export function goto (page) {
  let timestamp = Date.parse(new Date())
  page = page + '?_t=' + timestamp
  this.$router.push(page)
}


export function formatData (paramsData, tag) {
  // let param = '_t=' + new Date().valueOf()
  let param = ''
  for (let key in paramsData) {
    let value = paramsData[key]
    if (tag) {
      param = param + key + '=' + value + '&'
    } else {
      if (value) {
        param = param + key + '=' + value + '&'
      }
    }
  }
  return param
}

export function getOrderListByPid (pid, fn) {
  let _data = {
    pid: pid,
    orderid: '',
    skuname: '',
    vcode: '1',
    stime: '',
    etime: '',
  }
  getOrderListByData(_data, fn)
}

export function getOrderListByData (paramsData, fn) {
  // pid:推荐位ID 必须
  // orderid:订单号
  // skuname:商品名称
  // vcode:状态 默认1 为计费状态 0为异常状态
  // stime:开始时间 默认当天
  // etime:结束时间  默认当天
  // rnum:随机数
  let spid = paramsData.pid
  if (spid) {
    let randomNum = common.getRandom()
    let _md5 = md5(spid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.order_list + '?' + param
    this.$log(url)
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

export function getOrderCountByData (paramsData, fn) {
  // pid:推荐位ID 必须
  // stime:开始时间 默认当天
  // etime:结束时间  默认当天
  let spid = paramsData.pid
  if (spid) {
    let randomNum = common.getRandom()
    let _md5 = md5(spid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.order_count + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

export function getOrderChart (paramsData, fn) {
  let spid = paramsData.pid
  if (spid) {
    let randomNum = common.getRandom()
    let _md5 = md5(spid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.chart_list + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

export function getOrderLogListByData (paramsData, fn) {

  // pid:推广位ID(渠道ID) 必须
  // isValid:0为包含无效订单，1或其他为有效订单
  // orderId:搜索订单ID，非空时stime和etime失效
  // stime:开始时间 默认当天
  // etime:结束时间  默认当天
  // paga:当前页
  // size:每页条数
  // sort:排序desc或asc，默认为desc订单时间倒序
  // rnum:随机数
  let spid = paramsData.pid

  let param = formatData(paramsData)
  let url = common.order_log_list + '?' + param
  // this.$log(url);
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  }, function (err) {
    fn(err)
  })
}

export function getCategory (fn) {
  let url = common.get_category
  let _data = {
    parentId: 0,
    grade: 0,
  }
  postJson(url, _data).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

export function login (paramsData, fn) {
  let url = common.login
  let randomNum = common.getRandom()
  let _md5 = md5(randomNum + common.key).toLowerCase()
  paramsData.md5 = _md5
  paramsData.rnum = randomNum
  postData(url, paramsData).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 选品，搜索接口
 * @param json_params
 * @param fn
 */
export function getSelectGoods (json_params, fn) {
  // if(common.all_limit_words.includes(json_params.keyword)){
  //     fn({data:[]});
  //     return;
  // }
  let url = common.goods_query
  let params = common.copyObj(json_params)
  this.$log(params)
  postJson(url, params).then(response => {
    if (fn) {
      fn(response)
    }
    if (response && response.code === 200 && response.hotWords) {
      store.commit('setJdHotWords', response.hotWords)
    }
  })
}

/**
 * 礼金查询接口
 * @param json_params
 * @param fn
 */
export function getGiftQuery(json_params,fn){
  let url=common.gift_query
  let params = common.copyObj(json_params)
  this.$log(params)
  postJson(url, params).then(response => {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 礼金信息查询接口
 * @param json_params
 * @param fn
 */
export function getGiftInfo(json_params,fn){
  let url=common.gift_info
  let params = common.copyObj(json_params)
  this.$log(params)
  postJson(url, params).then(response => {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 获取商品详情,主要获取介绍内容
 * @param skuIds
 * @param fn
 */
export function getSkuBaseInfo (skuIds, fn) {
  if (skuIds) {
    let url = common.promotion_info_query
    url = url + '?skuIds=' + skuIds
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 获取商品详情,主要获取介绍内容
 * @param skuIds
 * @param fn
 */
export function getSkuBigInfo (json_params, fn) {
  if (json_params) {
    let url = common.goods_big_field
    let params = common.copyObj(json_params)
    postJson(url, params).then(response => {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 选品 京粉
 * @param json_params
 * @param fn
 */
export function getSelectJFGoods (json_params, fn) {
  let url = common.jingfen_query

  let params = common.copyObj(json_params)
  // this.$log(params)

  postJson(url, params).then(response => {
    if (fn) {
      fn(response)
    }
  })

}

export function getUnionLink (_data, fn) {
  let url = common.union_link
  let positionId = _data.positionId
  if (positionId && positionId.length < 3) {
    Dialog.alert({
      title: '错误',
      message: '您的渠道id异常，请退出重新登录；若仍无法正常使用，请联系客服'
    })
    return
  }
  postJson(url, _data).then(function (response) {
    if (response) {
      if (response.code === 500) {
        Dialog.alert({
          title: '错误',
          message: '您的渠道id异常，请退出重新登录；若仍无法正常使用，请联系客服'
        })
      } else {
        if (fn) {
          fn(response)
        }
      }
    } else {
      if (fn) {
        fn(null)
      }
    }
  })
}

/**
 * 获取url中指定参数的值
 * @param name
 * @return {string | null}
 */
export function getUrlParamValue (name) {
  // eslint-disable-next-line no-sparse-arrays
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

export function getSelectJFGoodsParams () {
  return {
    eliteId: 1,
    pageIndex: 1,
    pageSize: 40,
    sortName: '',
    sort: '',
    app_key: '',
    app_secret: '',
  }
}

export function getSelectGoodsParams () {
  return {
    cid1: -1, //一级类目id  Long
    cid2: -1, //二级类目id Long
    cid3: -1, //三级类目id   Long
    pageIndex: 1, //页码  Integer
    pageSize: 40, //每页数量，单页数最大30，默认20 Integer
    skuIds: [], //skuid集合(一次最多支持查询100个sku)，数组类型开发时记得加[] Long
    keyword: '', //关键词，字数同京东商品名称一致，目前未限制 String
    pricefrom: -1, //商品价格下限  Double
    priceto: -1, //商品价格上限  Double
    commissionShareStart: -1, //佣金比例区间开始 Integer
    commissionShareEnd: -1, //佣金比例区间结束  Integer
    owner: '', //商品类型：自营[g]，POP[p]  String
    sortName: '', //String //排序字段(price：单价, commissionShare：佣金比例, commission：佣金， inOrderCount30Days：30天引单量， inOrderComm30Days：30天支出佣金)
    sort: '', //asc,desc升降序,默认降序  String
    isCoupon: -1, //是否是优惠券商品，1：有优惠券，0：无优惠券  Integer
    isPG: -1, //是否是拼购商品，1：拼购商品，0：非拼购商品  Integer
    pingouPriceStart: -1, //拼购价格区间开始  Double
    pingouPriceEnd: -1, //拼购价格区间结束  Double
    isHot: -1, //是否是爆款，1：爆款商品，0：非爆款商品  Integer
    brandCode: '', //品牌code  String
    app_key: '',
    app_secret: '',
  }
}

/**
 * 用户可提款金额(多个渠道汇总)
 * @param paramsData
 * @param fn
 */
export function getUserPayToAll (paramsData, fn) {
  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.user_pay_to_all + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 用户可提款金额
 * @param paramsData
 * @param fn
 */
export function getUserPayTo (paramsData, fn) {
  let spid = paramsData.uid
  if (spid) {
    let randomNum = common.getRandom()
    let _md5 = md5(spid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.user_pay_to + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 用户可提款明细
 * @param paramsData
 * @param fn
 */
export function getUserPayList (paramsData, fn) {
  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.user_pay_list + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 提交提款
 * @param paramsData
 * @param fn
 */
export function getUserSubmit (paramsData, fn) {
  let uid = paramsData.uid
  let truename = paramsData.u_truename
  let account = paramsData.u_account
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + truename + account + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)
    this.$log(param)
    let url = common.user_submit
    post(url, param).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 获取系统配置
 * @param paramsData
 * @param fn
 */
export function getSubConfig (fn) {

  let randomNum = common.getRandom()
  let _md5 = md5(randomNum + common.key).toLowerCase()
  let paramsData = {
    md5: _md5,
    rnum: randomNum
  }

  let param = formatData(paramsData)
  this.$log('getSubConfig param = ' + param)
  let url = common.sub_config + '?' + param
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 用户上下级接口
 * @param paramsData
 * @param fn
 */
export function getUserLevel (paramsData, fn) {
  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.user_level + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 转链
 * @param paramsData
 * @param fn
 * @param error
 */
export function getChangeLink (paramsData, fn, error) {
  console.log(common.change_link)
  console.log(paramsData)
  //此处pid实际为username（即群号）
  let pid = paramsData.pid
  if (pid) {
    let url = common.change_link
    // if(paramsData.content){
    //     let _content = paramsData.content.replace(new RegExp('%','g'), '');
    //     _content = _content.replace(new RegExp('\\+','g'), '');
    //     paramsData.content = _content;
    // }
    postJsonForLongTimeout(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      if (error) {
        error(err)
      }
    })
  } else {
    fn({
      code: 500,
      temp: 500,
      message: '该活动仅限超级会员，您可完成超级会员任务，并升级为超级会员'
    })
  }
}

export function getBase64img (url) {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    xhr.open('get', url, true)
    xhr.responseType = 'blob'
    xhr.onload = function () {
      if (this.status === 200) {
        let blob = this.response
        let fileReader = new FileReader()
        fileReader.onloadend = function (e) {
          let result = e.target.result
          resolve(result)
        }
        fileReader.readAsDataURL(blob)
      }
    }
    xhr.onerror = function () {
      reject()
    }
    xhr.send()
  })
}

/**
 * 获取指定skuId所对应的商品信息
 * @param paramsData
 * @param fn
 */
export function getSelectSkuList (paramsData, fn) {
  let param = formatData(paramsData)
  let url = common.select_sku_list + '?' + param
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 获取分类列表
 * @param fn
 */
export function getCategoryList (fn) {
  let url = common.category_list
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 京东活动相关接口
 * @param paramsData
 * @param fn
 */
export function getEventsApi (paramsData, fn) {
  let param = formatData(paramsData)
  let url = common.events_api + '?' + param
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 代理通过下级和下下级所能获得的佣金提成的集合
 * @param paramsData
 * @param fn
 */
export function getPidLevelCountList (paramsData, fn) {
  let u_mark = paramsData.u_mark
  if (u_mark) {
    let randomNum = common.getRandom()
    let _md5 = md5(u_mark + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.pid_level_count_list + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 通过手机号注册群主
 * @param paramsData
 * @param fn
 */
export function getPhoneRegist (paramsData, fn) {
  let fid = paramsData.fid
  let phone = paramsData.phone
  let randomNum = common.getRandom()
  let _md5 = md5(phone + fid + randomNum + common.key).toLowerCase()
  paramsData.md5 = _md5
  paramsData.rnum = randomNum

  let param = formatData(paramsData)

  let url = common.phone_regist

  post(url, param).then(function (response) {
    if (fn) {
      fn(response)
    }
  }, function (err) {
    fn(err)
  })
}

/**
 * 修改密码
 * @param paramsData
 * @param fn
 */
export function modifyPassword (paramsData, fn) {
  let uid = paramsData.uid
  if (uid) {
    let npwd = paramsData.npwd
    let randomNum = common.getRandom()
    let _md5 = md5(uid + npwd + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.modify_password

    post(url, param).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取手机验证码
 * @param paramsData
 * @param fn
 */
export function getPhoneVerifyCode (paramsData, fn) {
  let phone = paramsData.phone
  if (phone) {

    let param = formatData(paramsData)

    let url = common.get_phone_verify_code + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 校验手机验证码
 * @param paramsData
 * @param fn
 */
export function checkPhoneVerifyCode (paramsData, fn) {
  let phone = paramsData.phone
  let code = paramsData.code
  if (phone && code) {

    let param = formatData(paramsData)

    let url = common.check_phone_verify_code + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取微信公众号的二维码地址，支持渠道号
 * @param paramsData
 * @param fn
 */
export function getWxQRUrl (fid, fn) {
  let paramsData = {
    fid: fid
  }

  let param = formatData(paramsData)

  let url = common.get_wx_qrurl + '?' + param
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  }, function (err) {
    fn(err)
  })
}

/**
 * 同步微信的openid到服务器
 * @param paramsData
 * @param fn
 */
export function syncUserOpenid (paramsData, fn) {
  let uid = paramsData.uid
  let oid = paramsData.oid
  if (uid && oid) {

    let randomNum = common.getRandom()
    let _md5 = md5(uid + oid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.user_openid_sync + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取微信小程序的二维码地址
 * @param paramsData
 * @param fn
 */
export function getWxAppQrcode (paramsData, fn) {
  let app_id = paramsData.app_id
  let app_secret = paramsData.app_secret
  let scene = paramsData.scene
  this.$log('scene = ' + scene)
  if (app_id && app_secret) {

    // paramsData.page = "";

    // let param = formatData(paramsData);

    let url = common.get_wx_app_qrcode
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 通过openid获取服务器端存储的用户信息
 * @param paramsData
 * @param fn
 */
export function getWxUserinfo (paramsData, fn) {
  let id = paramsData.id

  if (id) {

    let param = formatData(paramsData)

    let url = common.get_wx_userinfo + '?' + param
    if (config.project === 'hm') {
      delete paramsData.id
      paramsData.open_id = id
      param = formatData(paramsData)
      url = common.get_wx_userinfo_old + '?' + param
    }
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 通过openid小程序中获取用户信息(全局通用)
 * 存储用户信息到全局变量common.gloabl_wx_mini_user_info
 * 根据用户信息是否存在以及channel_id和channel_name是否有值，来判断存储小程序登录状态全局变量common.gloabl_wx_mini_login_status
 */
export function getGloabl_WxUserinfo (id, fn) {
  if (id) {
    let params = {
      id: id
    }

    getWxUserinfo(params, response => {
      this.$log(response)
      if (response && response.data) {
        //存储全局openid
        common.gloabl_wx_openid = response.data.open_id
        //存储全局user_info信息
        common.gloabl_wx_mini_user_info = response.data
        if (common.isBaidu_swan()) {
          common.gloabl_wx_mini_user_info.nickname = response.data.bd_user_name
          common.gloabl_wx_mini_user_info.headimgurl = response.data.bd_user_icon
        } else {
          common.gloabl_wx_mini_user_info.nickname = response.data.user_name
          common.gloabl_wx_mini_user_info.headimgurl = response.data.user_icon
        }

        if (response.data.channel_name && response.data.channel_name === 'guest') {
          common.gloabl_wx_mini_user_info.channel_id = ''
          common.gloabl_wx_mini_user_info.nickname = '游客'
          common.gloabl_wx_mini_user_info.headimgurl = 'user-circle-o'
        }

        //测试
        // common.gloabl_wx_mini_user_info.channel_id = "123456789";
        // common.gloabl_wx_mini_user_info.channel_name = "xiaonian";

        if (response.data.channel_id && response.data.channel_name) {
          //有channel_id和channel_name的为超级会员（群主）
          common.gloabl_wx_mini_login_status = 'super'
        } else {
          //没有channel_id和channel_name的为普通用户
          common.gloabl_wx_mini_login_status = 'normal'
        }
      } else {
        //未登录状态
        common.gloabl_wx_mini_login_status = 'none'

      }
      if (fn) {
        fn(common.gloabl_wx_mini_login_status)
      }
    })
  }
}

/**
 * 保存用户信息到服务器，并标识用户来自微信浏览器或公众号(wx)
 * @param paramsData
 * @param fn
 */
export function saveUserinfoToServer (paramsData, fn) {
  let id = paramsData.id
  let channel_name = paramsData.channel_name
  // paramsData.user_type = 'app';
  // paramsData.from_type = 'app';
  if (common.isBaidu_swan()) {
    paramsData.from_type = 'bd_app'
  } else {
    paramsData.from_type = 'wx_app'
  }

  if (id && channel_name) {

    // let param = formatData(paramsData);

    let url = common.save_app_user
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 修改手机号
 * @param paramsData
 * @param fn
 */
export function getUpdatePhone (paramsData, fn) {
  let uid = paramsData.uid
  let phone = paramsData.phone

  if (uid && phone) {

    let randomNum = common.getRandom()
    let _md5 = md5(uid + phone + randomNum + common.key).toLowerCase()
    let old_phone = paramsData.old_phone

    if (old_phone && typeof (old_phone) !== 'undefined') {
      _md5 = md5(uid + phone + old_phone + randomNum + common.key).toLowerCase()
    }

    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.update_phone + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取提款纪录
 * @param paramsData
 * @param fn
 */
export function getOrderBySumbit (paramsData, fn) {
  let uid = paramsData.uid

  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.get_order_by_sumbit

    post(url, param).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 订单详情下载xls
 * @param paramsData
 * @param fn
 */
export function getOrderByFinishXls (paramsData, fn) {
  let pid = paramsData.pid
  let stime = paramsData.stime

  if (pid && stime) {
    let randomNum = common.getRandom()
    let _md5 = md5(pid + stime + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.get_order_by_finish_xls

    post(url, param).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

export function getXls (url, fn) {
  let _url = url

  getExcel(_url).then(response => {

    const blob = new Blob([response], {
      type: 'application/vnd.ms-excel;'
    })
    if (fn) {
      fn(blob)
    }

  })
}

/**
 * 重置密码
 * @param paramsData
 * @param fn
 */
export function resetPassword (paramsData, fn) {
  let uid = paramsData.uid
  let phone = paramsData.phone

  if (uid && phone) {

    let randomNum = common.getRandom()
    let _md5 = md5(uid + phone + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.reset_password + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 上传图片
 * @param paramsData
 * @param fn
 */
export function postImage (paramsData, fn) {
  // let url = "http://jdpt.wanpu.com/admin/upload";
  let url = common.upload_image

  postImg(url, paramsData).then(function (response) {
    if (fn) {
      fn(response)
    }
  }, function (err) {
    fn(err)
  })
}

/**
 * 提交审核
 * @param paramsData
 * @param fn
 */
export function submitToExamine (paramsData, fn) {
  let channel_name = paramsData.channel_name

  if (channel_name) {
    // paramsData.open_id = "";
    // paramsData.phone = "13312345678";
    // paramsData.channel_name = "W123456"

    let param = formatData(paramsData)

    // let params =  JSON.stringify(paramsData)

    let url = common.submit_to_examine
    // let url = "http://192.168.11.162:8086/jd/JdParentVerify";
    this.$log(param)
    post(url, param).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 查询提交审核的状态
 * @param paramsData
 * @param fn
 */
export function checkExamine (paramsData, fn) {
  let phone = paramsData.phone

  if (phone) {

    let randomNum = common.getRandom()
    let _md5 = md5(phone + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.check_examine + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * //分享的注册成功后，发消息到指定的微信群
 * @param paramsData
 * @param fn
 */
export function sendMessageToWechat (paramsData, fn) {
  let content = paramsData.content

  if (content) {
    paramsData.chat_id = '5dd9e664bd6faa1c4e17402a'

    let url = common.send_message_to_wechat
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * //分享的注册成功后，发消息到指定的微信群(通过涂色机器人发送)
 * @param paramsData
 * @param fn
 */
export function sendMessageToWechat_ByTs (paramsData, fn) {
  let content = paramsData.content

  if (content) {
    // paramsData.chat_id = "5dd9e664bd6faa1c4e17402a";

    let url = common.send_message_to_wechat_by_ts
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

export function getQrUrl (paramsData, fn) {
  // let id = paramsData.id;
  // let channel_name = paramsData.channel_name;
  // paramsData.user_type = 'app';
  // paramsData.from_type = 'app';
  paramsData = {
    'action_info': {
      'scene': {
        'scene_str': 'a055'
      }
    },
    'action_name': 'QR_STR_SCENE',
    'expire_seconds': 2592000
  }
  let url = 'https://api.weixin.qq.com/cgi-bin/qrcode/create?access_token=27_TZu_DX_JIcSZqA6OKDNEpsRvNJ2ferwcLeq0BaQQ94f9pNT7zDg4XWhgaWjMu3Xw7Hbukmn8v4lZiJOMwXqa6QC1RrhgKcCasEBOGvTa1oEpfOcGdtwUxkNmDkwEHKfABARUX'
  postJson(url, paramsData).then(function (response) {
    if (fn) {
      fn(response)
    }
  }, function (err) {
    fn(err)
  })
}

/**
 * 获取粉丝列表
 * @param paramsData
 * @param fn
 */
export function getFansList (paramsData, fn) {
  let id = paramsData.id

  if (id) {

    let param = formatData(paramsData)

    let url = common.get_fans_list + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 通过手机号获取对应的账号列表
 * @param paramsData
 * @param fn
 */
export function getAccountListByPhone (paramsData, fn) {
  let phone = paramsData.phone

  if (phone) {
    let randomNum = common.getRandom()
    let _md5 = md5(phone + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.get_account_list_by_phone + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 自动登录
 * @param paramsData
 * @param fn
 */
export function auto_login (paramsData, fn) {
  let uname = paramsData.uname
  let upwd = paramsData.upwd
  if (uname && upwd) {
    let url = common.auto_login
    let randomNum = common.getRandom()
    let _md5 = md5(randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    postData(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 获取分享素材
 * @param paramsData
 * @param fn
 */
export function getShareDatas (fn) {
  let url = common.get_share_datas
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  }, function (err) {
    fn(err)
  })

  // let response = [
  //     {
  //         icon: "/images/jing_icon_1.png",
  //         title: "2019社交电商大趋势【发给想赚钱的好友】",
  //         content: "2019社交电商红利来袭，能省能赚，人人都可以创业\n" +
  //             "上班的发发朋友圈卖卖货\n" +
  //             "有车的下班当滴滴司机\n" +
  //             "懂金融的手里攥着股票\n" +
  //             "只有你还死守那一份固定工资，够花吗？\n" +
  //             "互联网时代，别浪费了你的人脉资源",
  //
  //         image: "/images/jing_icon_1.png",
  //     },
  //     {
  //         icon: "/images/pin_icon_2.png",
  //         title: "让你靠谱赚钱【发给想赚钱的好友】",
  //         content: "全流程微信操作，京东全平台商品\n" +
  //             "零收费，无风险，低门槛，高佣金\n" +
  //             "长按图片识别小程序\n" +
  //             "和我们一起靠谱躺赚~\n",
  //
  //         image: "/images/pin_icon_2.png",
  //     }
  // ];
  // fn(response);
}

/**
 * 获取群编号（自增，比实际存在的最后一个群编号大1）
 * @param paramsData
 * @param fn
 */
export function getNewChannelName (fn) {
  let url = common.get_new_channel_name
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  }, function (err) {
    fn(err)
  })
}

/**
 * 收入统计接口
 * @param paramsData
 * @param fn
 */
export function getIncometByData (paramsData, fn) {
  // pid:推荐位ID 必须
  // stime:开始时间 默认当天
  // etime:结束时间  默认当天
  let spid = paramsData.pid
  if (spid) {
    let randomNum = common.getRandom()
    let _md5 = md5(spid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.order_count_new + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 群下级人数
 * @param paramsData
 * @param fn
 */
export function getLevelCountTotal (paramsData, fn) {

  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.level_count_total + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 获取每日预估总收入的列表
 * @param paramsData
 * @param fn
 */
export function getEverydayCountList (paramsData, fn) {
  // uid:群号 必须
  // stime:开始时间 默认当天
  // etime:结束时间  默认当天
  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.get_everyday_count_list + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取每日预估推广收入的列表
 * @param paramsData
 * @param fn
 */
export function getEverydayUserCountList (paramsData, fn) {
  // uid:群号 必须
  // stime:开始时间 默认当天
  // etime:结束时间  默认当天
  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.get_everyday_user_count_list + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 群下级人数及收入
 * @param paramsData
 * @param fn
 */
export function getLevelCountData (paramsData, fn) {

  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.level_count_data + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * //注册成功后，发送账号密码到公众号
 * @param paramsData
 * @param fn
 */
export function sendMessageToPublic (paramsData, fn) {
  let touser = paramsData.touser

  if (touser) {

    let url = common.send_message_to_public
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取群组的活跃值
 * @param paramsData
 * @param fn
 */
export function getGroupActiveValue (paramsData, fn) {

  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum
    let param = formatData(paramsData)
    let url = common.get_group_active_value + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 获取插屏数据
 * @param paramsData
 * @param fn
 */
export function getPopDatas (fn) {
  let url = common.get_pop_datas
  get(url).then(function (response) {
    if (fn) {
      fn(response)
    }
  }, function (err) {
    fn(err)
  })

}

/**
 * 通过url和参数获取数据（基础get调用）
 * @param url
 * @param params
 * @param fn
 */
export function getDatasWithUrlAndParams (url, params, fn) {
  let param = formatData(params)
  let _url = ''
  if (url) {
    if (url.indexOf('?') > -1) {
      _url = url + '&' + param
    } else {
      _url = url + '?' + param
    }

    get(_url).then(function (response) {
      if (fn) {
        fn(response)
      }
    })
  }
}

/**
 * 通过url和参数获取数据（基础post调用）
 * @param json_params
 * @param fn
 */
export function getDatasWithUrlAndParams_Post (url, json_params, fn) {

  let params = common.copyObj(json_params)

  // this.$log(params)

  postJson(url, params).then(response => {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 点击推荐页面中的模块后的操作
 * @param item
 * @param fn
 */
export function clickHomeModelTo (item) {

  if (item && item.url) {
    item.url = item.url.replace(new RegExp(' ', 'g'), '')

    // item.url = "http://[channel].wapg.cn";

    // item.url = item.url + "&search_box=true&filter_box=false";

    if (item.url_type === 1) { //直接打开链接
      if (item.text && item.url && item.url.indexOf('/select?') !== -1 &&
        item.url.indexOf('grade') !== -1 && item.url.indexOf('cid') !== -1) {

        item.url = item.url + '&category_name=' + encodeURIComponent(item.text)
      }

      // item.url = '/#/all_search?active=2'

      if (common.gloabl_wx_mini_user_info && common.gloabl_wx_mini_user_info.id) {
        let _url = item.url
        this.$log(_url)

        // _url = '/#/all_search?active=2'
        // _url = '/#/?mini_page=../wp_eleme/wp_eleme'

        if (_url.indexOf('http:') === 0) {
          _url = _url.replace('http:', 'https:')
        }

        if (_url.indexOf('/#/') === 0) {
          _url = 'https://' + window.location.host + _url
        }

        if (this.$config.project === 'hm') {
          window.location.href = _url
        } else {

          if (_url.indexOf('/select') !== -1) {
            _url = _url.replace('/select?', '/mini_config?p=select&id=' + common.gloabl_wx_mini_user_info.id + '&')
          }
          if (_url.indexOf('/home_s') !== -1) {
            _url = _url.replace('/home_s?', '/mini_config?p=home_s&id=' + common.gloabl_wx_mini_user_info.id + '&')
          }
          if (_url.indexOf('/action_info') !== -1) {
            _url = _url.replace('/action_info?', '/mini_config?p=action_info&id=' + common.gloabl_wx_mini_user_info.id + '&')
          }
          // /#/all_search?active=0
          if (_url.indexOf('/all_search') !== -1) {
            _url = _url.replace('/all_search?', '/mini_config?p=all_search&id=' + common.gloabl_wx_mini_user_info.id + '&')
          }

            if (_url.indexOf('/gift') !== -1) {
                _url = _url.replace('/gift?', '/mini_config?p=gift&id=' + common.gloabl_wx_mini_user_info.id + '&')
            }

          if (_url.indexOf('?') !== -1) {
            _url = _url + '&_t=' + new Date().getTime()//加入一个随机数参数，避免缓存严重（小程序）
          } else {
            _url = _url + '?_t=' + new Date().getTime()//加入一个随机数参数，避免缓存严重（小程序）
          }
          this.$log(_url)

          // _url = "https://localhost:8080/#/?mini_page=../wp_eleme/wp_eleme"
          // _url = "https://localhost:8080/#/?mini_page=../wp_search/wp_search?search=小米"
          let _mini_page = common.getUrlKey2(_url, 'mini_page')
          //直接打开小程序指定page
          if (_mini_page) {
            common.navigateToMiniProgramPage(_mini_page)
            // common.navigateToMiniProgramPage("../" + _page + "/" + _page);
          } else {
            common.navigateToMiniProgramPage('../wp_webpage/wp_webpage?', '_url', _url)
          }
        }

        // window.location.href = item.url;
      } else {
        let _url = item.url
        if (_url.indexOf('mini_page') !== -1) {
          Dialog.alert({
            message: '请在万品京选小程序中使用'
          })
          return
        }
        if (_url.indexOf('/#/') !== -1) {
          _url = _url.replace('/#/', '/?_t=' + new Date().getMilliseconds() + '#/')
        }

        if (_url.indexOf('[channel]') !== -1) {
          let channel_name = common.getUsername()
          _url = _url.replace('[channel]', channel_name)
          // this.$log("_url = " +_url)
        }
        // this.$log("_url = " +_url)
        window.location.href = _url
        // window.location.replace(item.url)
      }

    } else if (item.url_type === 2) { //转链后打开
      //先转链

      let loadingToast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      let pid = common.getUsername()

      let params = {
        content: item.url,
        pid: pid
      }

      getChangeLink(params, response => {
        loadingToast.clear()
        if (response && response.code === 200) {
          if (response.content) {
            this.$log('response.content = ' + response.content)
            if (common.gloabl_wx_mini_user_info && common.gloabl_wx_mini_user_info.id) {
              //转链后小程序中打开
              common.navigateToMiniProgramPage('../wp_webpage/wp_webpage?', '_url', response.content)
            } else {
              //转链后h5中直接打开
              window.location.href = response.content
            }
          }
        } else {
          Toast.fail('不支持的url地址')
        }
      })
    } else if (item.url_type === 3) { //小程序中打开对应page
      if (common.gloabl_wx_mini_user_info && common.gloabl_wx_mini_user_info.id) {
        common.navigateToMiniProgramPage(item.url, null, null)
      } else {
        showMiniAppQrcodeImg()
      }

    } else if (item.url_type === 4) { //小程序中打开对应page
      if (common.gloabl_wx_mini_user_info && common.gloabl_wx_mini_user_info.id) {
        common.switchTabMiniProgramPage(item.url)
      } else {
        showMiniAppQrcodeImg()
      }
    }
    // else if(item.url_type === 5) {//
    //     window.location.href = item.url;
    // }
  }
}

export function showMiniAppQrcodeImg () {
  Dialog.alert({
    title: '小程序专用',
    message: '该功能仅支持小程序，您可识别[小程序码]，进入\'万品京选\'小程序，点击\'已有账号，直接登录\'，使用您的群号密码进行登录，然后在小程序中使用该功能',
    confirmButtonText: '小程序码',
    showCancelButton: true
  }).then(() => {
    getQrcodeUrl(img_url => {
      ImagePreview({
        images: [
          img_url
        ],
      })
    })
  })

}

export function getQrcodeUrl (fn) {
  // let u_code = encodeURIComponent("账号登录")
  let u_code = 'login'

  let params = {
    app_id: common.wx_app_id,
    app_secret: common.wx_app_secret,
    scene: u_code,
    width: 800
  }
  getWxAppQrcode(params, response => {
    if (response && response.data) {

      let qr_img_url = response.data
      if (qr_img_url) {
        if (fn) {
          fn(qr_img_url)
        }
      }
    } else {
      this.showLoading = false
      this.$dialog.alert({
        message: '该功能仅支持小程序，您可搜索\'万品京选\'小程序，进入后点击\'已有账号，直接登录\'，使用您的群号密码进行登录，然后在小程序中使用该功能'

      })
    }
  })
}

/**
 * 获取活动详情数据
 * @param params
 * @param fn
 */
export function getActionInfo (params, fn) {

  let param = formatData(params)

  let _url = common.get_action_info + '?' + param

  get(_url).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 获取活动列表数据
 * @param params
 * @param fn
 */
export function getActionList (params, fn) {

  let param = formatData(params)

  let _url = common.get_action_list + '?' + param

  get(_url).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

export function getPid (channel_name, fn) {
  let _url = common.get_pid + '?channel_name=' + channel_name

  get(_url).then(function (response) {
    if (fn) {
      fn(response)
    }
  })
}

/**
 * 获取返现数据
 * @param paramsData
 * @param fn
 */
export function getReturnCashData (paramsData, fn) {
  let ext_user = paramsData.ext_user
  if (ext_user) {
    let randomNum = common.getRandom()
    let _md5 = md5(ext_user + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.get_return_cash_data

    post(url, param).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 通过Channel_name获取该群中包含的机器人列表
 * @param paramsData
 * @param fn
 */
export function getRobotByChannelname (paramsData, fn) {
  let channel_name = paramsData.channel_name
  if (channel_name) {
    let url = common.get_robot_by_channelname
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取机器人列表()
 */
export function getRobotList (fn) {
  if (!common.global_robot_list || common.global_robot_list.length === 0) {
    let params = {
      channel_name: store.state.username,
    }

    getRobotByChannelname(params, response => {
      if (response && response.code == 200) {
        common.global_robot_list = response.data.list
        if (fn) {
          fn(common.global_robot_list)
        }
      }
    })
  } else {
    if (fn) {
      fn(common.global_robot_list)
    }
  }
}

/**
 * //提交群主要发的消息
 * @param paramsData
 * @param fn
 */
export function postContentToRobot (paramsData, fn) {
  let target_channel_name = paramsData.target_channel_name
  let message_list = paramsData.message_list
  if (target_channel_name && message_list && message_list.length > 0) {
    let url = common.post_content_to_robot
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取发送给助理的数据模板
 */
export function getPostToRobotData () {
  let params = {
    'message_list': [
      {
        'nVoiceTime': 0,
        'msgContent': '',
        'nMsgNum': 1,
        'nMsgType': 2002
      },
      {
        'nVoiceTime': 0,
        'msgContent': '',
        'nMsgNum': 2,
        'nMsgType': 2001
      }
    ],
    'target_channel_name': '',
    'task_status': 0,
    'send_day_order': 0,
    'id': '',
    'black_channel_name': '',
    'sku_id': '12345'
  }
  return params
}

/**
 * //获取群主提交发送内容列表
 * @param paramsData
 * @param fn
 */
export function getDataListFromRobot (paramsData, fn) {
  let channel_name = paramsData.channel_name
  if (channel_name) {
    let params = formatData(paramsData)
    let url = common.get_data_list_from_robot + '?' + params
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * //获取群主提交发送内容列表（未推送）
 * @param paramsData
 * @param fn
 */
export function getDataListFromRobot_noPush (fn) {
  let params_data = {
    channel_name: store.state.username,
    task_status: '0',
    page: '1',
    size: '200',
    send_day: common.getTodayDate(),
    // order: 'desc',
  }
  getDataListFromRobot(params_data, response => {
    if (response && response.code === 200) {
      if (response.data && response.data.list) {
        common.global_sku_no_push_data = response.data
        this.$log('no_push')
        this.$log(common.global_sku_no_push_data)
        if (fn) {
          fn(common.global_sku_no_push_data)
        }
      }
    }
  })
}

/**
 * //获取群主提交发送内容列表（已推送）
 * @param paramsData
 * @param fn
 */
export function getDataListFromRobot_Pushed (fn) {
  let params_data = {
    channel_name: store.state.username,
    task_status: '1',
    page: '1',
    size: '200',
    send_day: common.getTodayDate(),
    // order: 'desc',
  }
  getDataListFromRobot(params_data, response => {
    if (response && response.code === 200) {
      if (response.data) {
        common.global_sku_pushed_data = response.data
        this.$log('pushed')
        this.$log(common.global_sku_pushed_data)
        if (fn) {
          fn(common.global_sku_pushed_data)
        }
      }
    }
  })
}

/**
 * //获取群主提交发送内容列表（全部）
 * @param paramsData
 * @param fn
 */
export function getDataListFromRobot_All (fn) {
  let params_data = {
    channel_name: store.state.username,
    page: '1',
    size: '200',
    send_day: common.getTodayDate(),
    // order: 'desc',
  }
  getDataListFromRobot(params_data, response => {
    if (response && response.code === 200) {
      if (response.data) {
        common.global_sku_all_data = response.data
        // common.global_sku_all_data.time = new Date().getTime().toString();
        // this.$log('all')
        // this.$log(common.global_sku_all_data)
        if (fn) {
          fn(common.global_sku_all_data)
        }
      }
    }
  })
}

/**
 * //获取群主提交发送内容列表（全部），10分钟获取一次
 * @param paramsData
 * @param fn
 */
export function getAllDataListFromRobot_withLimitTime (fn) {
  // if(!common.global_robot_list || common.global_robot_list.length === 0){
  //     let params = {
  //         // channel_name: this.test_channel_name,
  //         channel_name: this.$store.state.username,
  //     };
  //     getRobotByChannelname(params,response=>{
  //         if(response && response.code == 200){
  //             common.global_robot_list = response.data.list;
  //             if(common.global_robot_list && common.global_robot_list.length > 0){
  //
  //             }
  //         }
  //     });
  // }

  let current_time = new Date().getTime()
  let old_time = store.state.query_sku_data_from_robot_time
  //10分钟限制
  if (current_time - old_time > 1000 * 60 * 10 || !common.global_sku_all_data || common.global_sku_all_data.list.length === 0) {
    store.commit('setQuerySkuDataTime', current_time)

    // this.$log("----查询群主提交内容的列表数据----")
    getDataListFromRobot_All(response => {
      if (fn) {
        fn(response)
      }
    })
  } else {
    // this.$log("----10分钟时限未到，不能查询----")
    if (fn) {
      fn(common.global_sku_all_data)
    }
  }
}

/**
 * //根据id删除群主提交发送内容列表中指定的一条
 * @param paramsData
 * @param fn
 */
export function deleteDataFromRobot (paramsData, fn) {
  let id = paramsData.id
  if (id) {
    let params = formatData(paramsData)
    let url = common.delete_data_from_robot + '?' + params
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 助理发品开关
 * @param paramsData
 * @param fn
 */
export function sendRobotStatus (paramsData, fn) {
  let room_id = paramsData.room_id
  let robot_id = paramsData.robot_id
  if (room_id && robot_id) {
    let url = common.robot_on_of
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 群主提交的发品内容(助理发品)排序
 * @param paramsData
 * @param fn
 */
export function sendRobotSkuList_Sorted (paramsData, fn) {
  let id_list = paramsData.id_list
  if (id_list && id_list.length > 0) {
    let url = common.robot_sku_list_sort
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  } else {
    Toast.fail({
      message: '没有排序数据'
    })
  }
}

/**
 * 获取用户信息(根据pid获取)
 * @param paramsData
 * @param fn
 */
export function getUserInfo (paramsData, fn) {
  let pid = paramsData.pid
  if (pid) {

    let randomNum = common.getRandom()
    let _md5 = md5(pid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.get_user_info + '?' + param
    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 发送微信昵称和头像数据到服务器
 * @param paramsData
 * @param fn
 */
export function postWxUserData (paramsData, fn) {
  let uid = paramsData.uid
  if (uid) {

    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.post_wx_user_data

    post(url, param).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取活动中奖励信息的状态数据
 * @param paramsData
 * @param fn
 */
export function getUserActiveStatus (paramsData, fn) {
  let uid = paramsData.uid
  if (uid) {

    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.get_user_active_status + '?' + param

    get(url).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 提交获取奖励的数据
 * @param paramsData
 * @param fn
 */
export function submitToGetAward (paramsData, fn) {
  let uid = paramsData.uid
  if (uid) {
    let randomNum = common.getRandom()
    let _md5 = md5(uid + randomNum + common.key).toLowerCase()
    paramsData.md5 = _md5
    paramsData.rnum = randomNum

    let param = formatData(paramsData)

    let url = common.submit_to_get_award

    post(url, param).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}

/**
 * 获取公众号签名（微信js api wx.config接口使用）
 * @param paramsData
 * @param fn
 */
export function getWxPublicSignature (paramsData, fn) {
  let _app_id = paramsData.app_id
  if (_app_id) {
    let url = common.get_wx_public_signature
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  } else {
    Toast.fail({
      message: '获取微信公众号签名数据失败'
    })
  }
}

/**
 * 保存短链
 * @param paramsData
 * @param fn
 */
export function saveShortUrl (paramsData, fn) {
  let _url = paramsData.url
  if (_url) {
    let url = common.save_short_url
    postJson(url, paramsData).then(function (response) {
      if (fn) {
        fn(response)
      }
    }, function (err) {
      fn(err)
    })
  }
}